export const apiMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    const BASE_URL = "https://fakestoreapi.com";
    if (action.type === "api/makeCall") {
      next(action); // for debugging
      const { url, onStart, onSuccess, onError } = action.payload;
      dispatch({
        type: onStart,
      });
      fetch(`${BASE_URL}/${url}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(
              "Failed to fetch products. Please try again later."
            );
          }
          return res.json();
        })
        .then((data) => {
          dispatch({
            type: onSuccess,
            payload: data,
          });
        })
        .catch((err) => {
          dispatch({
            type: onError,
            payload: err.message,
          });
        });
    } else next(action);
  };

//api action creator
export const fetchData = (payload) => ({
  type: "api/makeCall",
  payload: payload,
});
